import { useState, useEffect } from "react";
import img from "../../../Assets/about-us/faq-img.png";
import API from "../../../Utils/api";

// Skeleton
const FaqSkeleton = () => (
  <div className="space-y-4 mt-6">
    {Array.from({ length: 5 }).map((_, i) => (
      <div key={i} className="border rounded-md p-4 bg-white border-gray-200 animate-pulse">
        <div className="flex justify-between items-center">
          <div className="h-4 bg-gray-200 rounded w-3/4" />
          <div className="h-5 w-5 bg-gray-200 rounded" />
        </div>
      </div>
    ))}
  </div>
);

const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState(0);
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchFaqs = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await API.get('/faq/get-all');
      const data = Array.isArray(res.data) ? res.data : res.data.data || [];
      setFaqs(data);
    } catch (error) {
      console.error('Error fetching FAQs:', error);
      setError('Failed to load FAQs.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFaqs();
  }, []);

  return (
    <div className="flex flex-col md:flex-row items-start py-10 px-4 gap-8 md:px-10">

      {/* Left Column: FAQ */}
      <div className="w-full md:w-[70%]">
        <h2 className="text-2xl md:text-4xl font-serif text-[#000000]">
          Frequently asked questions
        </h2>

        {/* Loading */}
        {loading && <FaqSkeleton />}

        {/* Error */}
        {error && !loading && (
          <div className="flex flex-col items-center py-12 text-center">
            <span className="text-4xl mb-3">😕</span>
            <p className="text-gray-500 text-sm">{error}</p>
            <button
              onClick={fetchFaqs}
              className="mt-3 px-5 py-1.5 bg-[#92AD36] text-white rounded-lg text-xs hover:bg-[#7a9230] transition"
            >
              Try Again
            </button>
          </div>
        )}

        {/* Empty */}
        {!loading && !error && faqs.length === 0 && (
          <div className="flex flex-col items-center py-12 text-center">
            <span className="text-4xl mb-3">❓</span>
            <p className="text-gray-500 text-sm">No FAQs available yet</p>
          </div>
        )}

        {/* FAQ List */}
        {!loading && faqs.length > 0 && (
          <div className="space-y-4 mt-6">
            {faqs.map((faq, index) => (
              <div
                key={faq._id}
                className={`border rounded-md p-4 transition-all duration-200 ${
                  openIndex === index
                    ? "bg-yellow-50 border-[#92AD36]"
                    : "bg-white border-gray-200"
                }`}
              >
                <div
                  onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                  className="flex justify-between items-center cursor-pointer"
                >
                  <h3
                    className={`font-semibold text-[16px] leading-[150%] tracking-wide font-montserrat ${
                      openIndex === index ? "text-[#92AD36]" : "text-[#666666]"
                    }`}
                  >
                    {faq.question}
                  </h3>
                  <span className="text-xl font-bold text-gray-500 flex-shrink-0 ml-3">
                    {openIndex === index ? "−" : "+"}
                  </span>
                </div>
                {openIndex === index && (
                  <p className="mt-2 text-[#666666] font-normal text-[14px] leading-[150%] tracking-wide font-montserrat">
                    {faq.answer}
                  </p>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Right Column: Image */}
      <div className="w-full md:w-[30%]">
        <img
          src={img}
          alt="Engineer"
          className="rounded-lg shadow-lg w-full max-h-[506px] object-cover"
        />
      </div>
    </div>
  );
};

export default FaqSection;